import React from 'react';
import { useTranslation } from 'react-i18next';
import { LinkModal } from '../../../components/ATS/LinkModal/LinkModal';
import { ScriptService } from '../../../controllers/ScriptService';
import { PopUpTextType } from '../../../queries/ats/me/providers/types';
import { getAltiboxServiceUrl } from '../../../utils/svodUtil';

export interface ThirdPartyDeepLinkProps {
  type: PopUpTextType;
  link: URL | string;
  providerIdentifier: string;
  providerName: string;
  children: JSX.Element;
  track?: () => void;
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
}

export function ThirdPartyDeepLink({
  type,
  link,
  providerIdentifier,
  providerName,
  children,
  track,
  onClick,
}: ThirdPartyDeepLinkProps) {
  const { t } = useTranslation();

  const isDKUser = ScriptService.isDKUser();

  const url = getAltiboxServiceUrl(providerIdentifier);
  const description = useThirdPartyPoupDescription(type, providerName);

  if (type === 'free' || type === 'vendor') {
    return (
      <LinkModal
        id={`${providerIdentifier}-${type}`}
        title={t('thirdparty:popup_title', { name: providerName })}
        description={description}
        onClick={onClick}
        primaryButton={{
          title: t('thirdparty:popup_continue_to', { name: providerName }),
          url: link.toString(),
          onClick: track,
        }}
      >
        {children}
      </LinkModal>
    );
  }

  return (
    <LinkModal
      id={`${providerIdentifier}-${type}`}
      title={t('thirdparty:popup_title', { name: providerName })}
      description={description}
      onClick={onClick}
      primaryButton={{
        title: t('thirdparty:popup_go_to', { name: isDKUser ? 'customer support' : 'Altibox.no' }),
        url: url,
      }}
      secondaryButton={{
        title: t('thirdparty:popup_continue_to', { name: providerName }),
        url: link.toString(),
        onClick: track,
      }}
    >
      {children}
    </LinkModal>
  );
}

function useThirdPartyPoupDescription(type: PopUpTextType, name: string) {
  const { t } = useTranslation();

  switch (type) {
    case 'free':
      return t('thirdparty:popup_description_free', { name });
    case 'points':
      return t('thirdparty:popup_description_points');
    case 'vendor':
      return t('thirdparty:popup_description_vendor', { name });
    case 'money':
      return t('thirdparty:popup_description_money');
    case 'danish':
      return t('thirdparty:popup_description_danish');
    default:
      return 'unknown message';
  }
}
